import { FETCH_METERS_REQUEST, FETCH_METERS_SUCCESS, FETCH_METERS_FAILURE } from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
  receivedAt: null,
};

const metersReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_METERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_METERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
        receivedAt: action.meta?.receivedAt || Date.now(),
      };
    case FETCH_METERS_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default metersReducer;
